export const CALENDAR_SOCIAL_PRESS_CONSTANTS = [
  `“Sync all of the family’s calendars into one easy-to-use touchscreen device”`,
  `“An all-in-one planning tool for the whole family”`,
  `“Products that *finally* helped my family get organized”`,
  `“Perfect for the mom who’s juggling several different schedules”`,
]

export const FRAME_PRESS_CONSTANTS = [
  `“I've started thinking of the Skylight Calendar as a second brain or, as my 10-year-old calls it, a 'remembering system.'”`,
  `“Genius… that's a great gift”`,
  `“It's a great way for grandparents to view all the latest grandkid exploits.”`,
]
